import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import './CharacterCard.css';

const CharacterCard = ({ character, index }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const { ref, controls } = useScrollAnimation();

  const cardVariants = {
    hidden: { 
      opacity: 0, 
      y: 100,
      rotateX: -30
    },
    visible: { 
      opacity: 1, 
      y: 0,
      rotateX: 0,
      transition: { 
        duration: 0.8,
        delay: index * 0.15,
        type: "spring",
        bounce: 0.4
      }
    }
  };

  const hoverVariants = {
    initial: { scale: 1 },
    hover: { 
      scale: 1.05,
      transition: { 
        duration: 0.3,
        yoyo: Infinity,
        ease: "easeInOut"
      }
    }
  };

  
  const bloodDrops = [...Array(20)].map((_, i) => ({
    id: i,
    left: `${Math.random() * 100}%`,
    delay: Math.random() * 2,
    size: Math.random() * 10 + 5
  }));

  return (
    <motion.div
      ref={ref}
      variants={cardVariants}
      initial="hidden"
      animate={controls}
      className="character-card"
      style={{ 
        background: character.bgGradient,
        borderColor: character.color
      }}
      onHoverStart={() => setIsHovered(true)}
      onHoverEnd={() => setIsHovered(false)}
      onClick={() => setIsClicked(!isClicked)}
    >
      {}
      {isHovered && bloodDrops.map(drop => (
        <motion.div
          key={drop.id}
          className="blood-drop"
          initial={{ 
            top: -20, 
            left: drop.left,
            width: drop.size,
            height: drop.size,
            opacity: 0.7
          }}
          animate={{ 
            top: '120%',
            opacity: 0
          }}
          transition={{ 
            duration: 2,
            delay: drop.delay,
            repeat: Infinity,
            ease: "linear"
          }}
          style={{ background: character.color }}
        />
      ))}

      {}
      <motion.div 
        className="card-header"
        animate={isHovered ? { 
          x: [0, -5, 5, -5, 5, 0],
          transition: { duration: 0.5 }
        } : {}}
      >
        <span className="character-icon">{character.icon}</span>
        <h2 style={{ color: character.color }}>{character.name}</h2>
        <span className="character-title">{character.title}</span>
      </motion.div>

      {}
      <motion.div 
        className="character-portrait"
        animate={isHovered ? {
          scale: [1, 1.1, 1],
          filter: [
            'brightness(1)',
            'brightness(1.5) contrast(1.5)',
            'brightness(1)'
          ],
          transition: { duration: 0.8, repeat: Infinity }
        } : {}}
      >
        <div className="portrait-glow" style={{ background: character.color }} />
        
        {}
        {isHovered && character.name === "ДЕНДЖИ" && (
          <>
            <motion.div 
              className="chainsaw-blade top"
              initial={{ rotate: -45, x: -50, y: -30 }}
              animate={{ 
                rotate: [-45, 0, -45],
                x: [-50, 20, -50],
                y: [-30, -60, -30]
              }}
              transition={{ duration: 0.3, repeat: Infinity }}
            />
            <motion.div 
              className="chainsaw-blade right"
              initial={{ rotate: 45, x: 50, y: -30 }}
              animate={{ 
                rotate: [45, 90, 45],
                x: [50, 80, 50],
                y: [-30, -60, -30]
              }}
              transition={{ duration: 0.3, repeat: Infinity }}
            />
          </>
        )}
      </motion.div>

      <motion.div 
        className="ability-section"
        animate={isHovered ? { 
          height: 'auto',
          opacity: 1
        } : { 
          height: 0,
          opacity: 0
        }}
      >
        <h3 style={{ color: character.color }}>◉ {character.ability}</h3>
        <p>{character.abilityDesc}</p>
      </motion.div>

    
      {isClicked && (
        <motion.div 
          className="character-details"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
        >
          <div className="detail-item">
            <span>💉 Тип крови:</span>
            <p>{character.bloodType}</p>
          </div>
          <div className="detail-item">
            <span>❤️ Любит:</span>
            <p>{character.likes}</p>
          </div>
          <div className="detail-item quote">
            <span>❝</span>
            <p>{character.quote}</p>
            <span>❞</span>
          </div>
        </motion.div>
      )}

      <motion.div 
        className="click-hint"
        animate={{ 
          scale: [1, 1.2, 1],
          opacity: [0.3, 0.8, 0.3]
        }}
        transition={{ duration: 2, repeat: Infinity }}
      >
        {isClicked ? '▼ СВЕРНУТЬ' : '▲ ПОДРОБНЕЕ'}
      </motion.div>
    </motion.div>
  );
};

export default CharacterCard;